import { render, staticRenderFns } from "./dashboard-activity.vue?vue&type=template&id=25dbc0d0&scoped=true&"
import script from "./dashboard-activity.vue?vue&type=script&lang=js&"
export * from "./dashboard-activity.vue?vue&type=script&lang=js&"
import style0 from "./dashboard-activity.vue?vue&type=style&index=0&id=25dbc0d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25dbc0d0",
  null
  
)

export default component.exports